import { Flex, Text, Separator, Link } from '@radix-ui/themes';
import './Footer.css';
import axiomLogo from '../../assets/axiom-logo.svg';
import { useSiteConfig } from '../../utils/siteConfig';

const Footer: React.FC = () => {
  const { get } = useSiteConfig();
  const phone = get('contactPhone', '(970) 684-4311');
  const email = get('contactEmail', 'contact@westslopequiz.com');
  // ponytail: assumes US numbers when no country code is given
  const digits = phone.replace(/[^+\d]/g, '');
  const phoneHref = digits.startsWith('+') ? digits : `+1${digits}`;
  return (
    <footer className="footer">
      <Flex direction="column" align="center" gap="1" width="100%" className="footer-content">
        <Separator size="4" style={{ opacity: 0.2 }} />
        <Flex align="center" gap="2" className="footer-contact">
          <Link size={{ initial: '1', md: '2' }} href={`tel:${phoneHref}`}>{phone}</Link>
          <Separator orientation="vertical" size="1" />
          <Link size={{ initial: '1', md: '2' }} href={`mailto:${email}`}>{email}</Link>
        </Flex>
        <Flex align="center" gap="2" className="logo">
          <img src={axiomLogo} alt="Axiom Logo" />
          <Text size={{ initial: '1', md: '2' }}>Made by Axiom Software, LLC</Text>
        </Flex>
      </Flex>
    </footer>
  );
};

export default Footer;
